import { http } from '../api/client';

export const authService = {
    login: (config) => http.post('/auth/login', config),
    logout: () => http.get('/auth/logout'),
    verifyEmail: (token) => http.post('/auth/verify-email', { token }),
}